import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const signUpRequest = ({
  payload,
  redirectTo,
  callbacks,
}: {
  payload: {
    email: string,
    password: string,
    is_pro?: boolean,
    is_client?: boolean,
    invitation_token?: string,
  },
  redirectTo: string,
  callbacks: SagaCallbacks,
}): Action => ({
  type: actionTypes.SIGN_UP_REQUEST,
  payload,
  redirectTo,
  callbacks,
});

export const loginRequest = ({
  payload,
  redirectTo,
  callbacks,
}: {
  payload: {
    username: string,
    password: string,
  },
  redirectTo?: string,
  callbacks: SagaCallbacks,
}): Action => ({
  type: actionTypes.LOGIN_REQUEST,
  payload,
  redirectTo,
  callbacks,
});

export const loginWithProviderRequest = (
  payload: any,
  provider: string,
): Action => ({
  type: actionTypes.LOGIN_WITH_PROVIDER_REQUEST,
  payload,
  meta: {
    provider,
  },
});

export const loginWithToken = (
  accessToken: string,
): Action => ({
  type: actionTypes.LOGIN_WITH_TOKEN_REQUEST,
  accessToken,
});

export const confirmEmail = (
  token: string,
  onSuccess,
  onError,
): Action => ({
  type: actionTypes.REQUEST_CONFIRM_EMAIL,
  token,
  callbacks: {
    onSuccess,
    onError,
  },
});

export const resetPasswordRequest = (
  payload: {
    email: string,
  },
  callbacks: SagaCallbacks,
): Action => ({
  type: actionTypes.RESET_PASSWORD_REQUEST,
  payload,
  callbacks,
});

export const confirmPasswordRequest = ({
  payload,
  callbacks,
}: {
  payload: any,
  callbacks?: SagaCallbacks,
}): Action => ({
  type: actionTypes.CONFIRM_PASSWORD_REQUEST,
  payload,
  callbacks,
});

export const checkEmail = ({
  email,
  callbacks,
}: {
  email: string,
  callbacks: SagaCallbacks,
}): Action => ({
  type: actionTypes.REQUEST_CHECK_EMAIL,
  email,
  callbacks,
});

export const logoutRequest = () => ({
  type: actionTypes.REQUEST_LOGOUT,
});

export const profileSetupRequest = ({
  payload,
  settings,
  callbacks,
}: {
  payload: any,
  settings: any,
  callbacks: SagaCallbacks,
}) => ({
  type: actionTypes.PROFILE_SETUP_REQUEST,
  payload,
  settings,
  callbacks,
});

export const requestStripeConnect = ({
  qs,
  callbacks,
}: {
  qs: any,
  callbacks: SagaCallbacks,
}) => ({
  type: actionTypes.REQUEST_CONNECT_STRIPE,
  qs,
  callbacks,
});

export const requestCreateUser = ({
  data,
  callbacks,
}: {
  data: any,
  callbacks: SagaCallbacks,
}) => ({
  type: actionTypes.REQUEST_CREATE_USER,
  data,
  callbacks,
});

export const requestUpgradeAccount = ({
  endpoint,
  callbacks,
}: {
  endpoint: 'upgrade' | 'hts',
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_UPGRADE_ACCOUNT,
  endpoint,
  callbacks,
});

export const requestGetUpgradeAccountPlan = ({
  callbacks,
}: {
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_GET_UPGRADE_ACCOUNT_PLAN,
  callbacks,
});
